import React from 'react'
import useHistoryTimeline from '#/containers/PropertyDetail/hooks/useHistoryTimeline'
import styles from '../styles.module.scss'
import HistoryEvent from './HistoryEvent'

export default function HistoryTimeline({ history }: {
  history: TopHap.PropertyTransaction[]
}) {
  const items = useHistoryTimeline(history)

  return (
    <ul className={styles['th-history-timeline']}>
      {items.map((e, index) => (
        <HistoryEvent key={index} {...e} />
      ))}
    </ul>
  )
}
